export default {
  slug: "teamcity",
  code: "TC",
  label: "TeamCity",
  krakenDir: "TeamCity",
  thumbnailColor: "#3BEA62",
  logoFamily: "jb",
};
